<div class="page-container gap-36">
  <app-table-header-navigation
    [isLoading]="isLoading"
    [slides]="cardSlides"
    (cardClicked)="onCardClicked($event)"></app-table-header-navigation>
  <div class="font-bold-display-medium">
    {{ seminarDateSeries.seminar.title }}
  </div>
  <app-custom-table
    class="padding-bottom-24"
    [pageSizeOptions]="[5, 10, 25, 50, 100]"
    titleMultipleResults="Teilnehmer"
    titleSingleResult="Teilnehmer"
    [tableHeaderButton]="tableHeaderButton"
    [dataSource$]="dataSource$"
    [columns]="columns"
    [isLoading]="isLoading"
    [filters]="filters"
    noDataIcon="fa-users"
    noDataMessage="Es gibt derzeit keine Teilnehmer."
    noSearchResultsIcon="fa-users"
    noSearchResultsMessage="Es gibt keine Teilnehmer, die mit deinen Suchkriterien übereinstimmen."></app-custom-table>
</div>
